var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma-1-copy",
    fill: "#656565",
    d: "M1154 581c-3.31 0-6 2.839-6 6.328 0 1.179.31 2.33.9 3.328l4.76 8.095c.09.155.25.249.42.249h.01a.496.496 0 00.42-.256l4.64-8.174a6.52 6.52 0 00.85-3.242c0-3.489-2.69-6.328-6-6.328zm4.3 9.029l-4.22 7.431-4.33-7.36a5.467 5.467 0 01-.76-2.772c0-2.908 2.25-5.28 5.01-5.28s5 2.372 5 5.28c0 .954-.24 1.888-.7 2.701zm-4.3-5.865c-1.65 0-3 1.419-3 3.164 0 1.734 1.32 3.164 3 3.164 1.7 0 3-1.449 3-3.164 0-1.745-1.35-3.164-3-3.164zm0 5.28c-1.11 0-2.01-.95-2.01-2.116 0-1.163.91-2.116 2.01-2.116 1.1 0 2 .953 2 2.116 0 1.149-.87 2.116-2 2.116z",
    transform: "translate(-1134 -570)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.dd12fdadebb8c91a4599119ceb98fbc6.svg";
export { ForwardRef as ReactComponent };